// The purpose of this function is to be used in the value prop to allow '0' in MUI Text Fields.
export function emptyIfNullOrUndefined(value: any): any {
  if (value === null || value === undefined) {
    return '';
  }

  return value;
}
